import axiosInstance from "../../utility/axios";

// state
import openNotification from "../../modules/toasts/index";
import {
  deleteService,
  setLoading,
  createService,
  setServices,
  setTotal,
  editService,
  setService,
  setLoadingServiceId,
} from "../../store/slices/services";
import { AppDispatch } from "../../store/store";
import { isAxiosError } from "axios";
import {
  ICreateService,
  IEditService,
  // IUpdateStatus,
} from "../../store/types/service";
import { toast } from "sonner";

export const get_services = async (dispatch: AppDispatch) => {
  dispatch(setLoading());
  try {
    const response = await axiosInstance.get("/v1/get-services"); // show-file-logs

    dispatch(setServices(response?.data?.data));
  } catch (err: any) {
    if (isAxiosError(err)) {
      openNotification({
        type: "error",
        title: "Incorrect Credentials",
        description: err?.response?.data?.message,
      });
    }
  }
  dispatch(setLoading());
};

export const get_service = async (dispatch: AppDispatch, id: string) => {
  dispatch(setLoading());
  try {
    const response = await axiosInstance.get(`/v1/get-service/${id}`);

    const { data } = response?.data;
    dispatch(setService(data));
  } catch (err: any) {
    if (isAxiosError(err)) {
    }
  }
  dispatch(setLoading());
};

export const create_service = async (
  form: ICreateService,
  dispatch: AppDispatch,
) => {
  dispatch(setLoading());
  try {
    const response = await axiosInstance.post("/v1/create-service", form);

    const { message, data } = response.data;
    toast.success(message || "Service created successfully");

    dispatch(createService(data));
    dispatch(setLoading());
    return true;
  } catch (err: any) {
    if (isAxiosError(err))
      toast.error(err?.response?.data?.message || "Failed to create service");
    dispatch(setLoading());
    return false;
  }
};

export const edit_service = async (
  form: IEditService,
  dispatch: AppDispatch,
) => {
  dispatch(setLoading());
  try {
    const response = await axiosInstance.patch(`/v1/update-service`, form);

    const { data, message } = response.data;
    toast.success(message || "Service updated successfully");
    dispatch(editService(data));
    dispatch(setService(data));
    dispatch(setLoading());
    return true;
  } catch (err) {
    if (isAxiosError(err))
      toast.error(err?.response?.data?.message || "Failed to update service");
    dispatch(setLoading());
    return false;
  }
};

export const delete_service = async (dispatch: AppDispatch, id: string) => {
  dispatch(setLoadingServiceId(id));
  try {
    const response = await axiosInstance.delete(`/v1/delete-service/${id}`);
    const { message } = response.data;
    dispatch(deleteService(id));
    toast.success(message || "Service deleted successfully");
  } catch (err: any) {
    if (isAxiosError(err)) {
      toast.error(err?.response?.data?.message || "Failed to delete service");
    }
  } finally {
    dispatch(setLoadingServiceId(null));
  }
};

// ================================================================================

export const get_total = async (dispatch: AppDispatch) => {
  dispatch(setLoading());
  try {
    const response = await axiosInstance("/v1/get-total-service");

    const { data } = response.data;
    dispatch(setTotal(data));
  } catch (error) {
    if (isAxiosError(error)) console.log(error);
  }
  dispatch(setLoading());
};

export const update_status = async (dispatch: AppDispatch, id: string) => {
  try {
    const response = await axiosInstance.patch(
      `/v1/update-service-status/${id}`,
    );

    const { data, message } = response.data;
    dispatch(editService(data));
    dispatch(setService(data));
    toast.success(message || "Service status updated successfully");
  } catch (err: any) {
    if (isAxiosError(err)) {
      const { message } = err?.response?.data;
      toast.error(message || "Failed to update service status");
    }
  }
};

export const delete_package = async (dispatch: AppDispatch, id: string) => {
  try {
    const response = await axiosInstance.delete(`v1/delete-package/${id}`);

    const { message, data } = response.data;
    dispatch(editService(response?.data?.data));
    dispatch(setService(data));
    toast.success(message || "Package deleted successfully");
  } catch (err: any) {
    if (isAxiosError(err)) {
      const { message } = err?.response?.data;
      toast.error(message || "Failed to delete package");
    }
  }
};
